/**
 * originally part of react-apollo lib, see
 * https://github.com/apollographql/react-apollo/blob/release-2-maintenance/src/utils/flowRight.ts
 */

export const compose = (...inputFunctions: Array<(...args: any[]) => any>): ((...args: any[]) => any) => {
  const functions = inputFunctions.reverse();
  return (...args: any[]) => {
    const [firstFunction, ...restFunctions] = functions;
    let result = firstFunction(...args);
    restFunctions.forEach((fnc) => {
      result = fnc.call(null, result);
    });
    return result;
  };
};
